import React from 'react';
import Spacing from '../Spacing';

export default function Section({
  top = '_',
  topMd = '_',
  topLg = '_',
  topXl = '_',

  bottom = '_',
  bottomMd = '_',
  bottomLg = '_',
  bottomXl = '_',

  children,
  ...props
}) {
  return (
    <section {...props}>
      <Spacing
        sm={top}
        md={topMd}
        lg={topLg}
        xl={topXl}
      />

      {children}

      <Spacing
        sm={bottom}
        md={bottomMd}
        lg={bottomLg}
        xl={bottomXl}
      />
    </section>
  );
}